export const VILNIUS_BRIDGE_MANIFEST_URL =
  "/assets/bridges/manifest.json";

export const VILNIUS_BRIDGE_COLLISION_MANIFEST_URL =
  "/assets/bridges/collision-manifest.json";

/** 23 generated crossings plus the White Bridge retained in landmarks. */
export const VILNIUS_EXISTING_NAMED_BRIDGE_COUNT = 24;
